import React from "react";
import { node } from "prop-types";

const CardPriceOne = ({ price, period, children }) => {
	return (
		<div className="card-price__one">
			<div className="card-price__one-price">{price}</div>
			<div className="card-price__one-period">{period}</div>
			{children}
		</div>
	);
};

CardPriceOne.propTypes = {
	price: node.isRequired,
	period: node.isRequired,
	children: node,
};

export default CardPriceOne;
